import firebase from "firebase/app";

import "firebase/analytics";
import "firebase/functions";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/performance";

const DEV_CONFIG = {
  apiKey: "AIzaSyAR5QcmLNUeqygT6Op8XVfbeh-7WI2MRO4",
  authDomain: "avvapp-b5fe7.firebaseapp.com",
  databaseURL: "https://avvapp-b5fe7.firebaseio.com",
  projectId: "avvapp-b5fe7",
  storageBucket: "avvapp-b5fe7.appspot.com",
  messagingSenderId: "94269155851",
  appId: "1:94269155851:web:1848d60bced2f83f43f50e",
  measurementId: "G-D1MFRB97ND"
}

firebase.initializeApp(DEV_CONFIG); /** ==================================CHANGE THIS WHILE DEPLOYING ========*/

export default firebase;
export const analytics = firebase.analytics();
export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const storage = firebase.storage();
export const performance = firebase.performance();
export const functions = firebase.functions();

export async function createUser(user) {
  
}